import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import counterpart from 'counterpart';
import { connect } from 'react-redux';
import { Switch, Radio } from 'antd';
import ClickOutside from 'react-click-outside';
import Translate from 'react-translate-component';

import { isAncor } from 'utils/version';
import { isNotificationsEnabled } from 'utils/firebase';
import colorSchemes from 'constants/colorSchemes';
import { changeLanguage, pinLeftMenu, changeColorScheme } from 'actions/appActions';
import { getCompanyInfo } from 'actions/asyncActions';
import { closestElementWithClass } from 'components/sidebars/SidebarSwitcher';
import Notifications from './Notifications';
import CustomIcon from 'components/common/CustomIcon';

const isSettingsIcon = closestElementWithClass('settings-item');
const isNotificationTarget = closestElementWithClass('push-confirm-modal');

const stateToProps = ({ leftMenu:{ leftMenuPinned }, colorScheme, ...state }) => ({
    leftMenuPinned,
    colorScheme,
    sso: !!getCompanyInfo.selectData(state).sso,
});

const dispatchToProps = {
    changeLanguage,
    pinLeftMenu,
    changeColorScheme,
};

@connect(stateToProps, dispatchToProps)
@ClickOutside
export default class SettingsSidebar extends Component {
    static propTypes = {
        close: PropTypes.func.isRequired,
        changeLanguage: PropTypes.func.isRequired,
        pinLeftMenu: PropTypes.func.isRequired,
        leftMenuPinned: PropTypes.bool.isRequired,
        withoutPinLeft: PropTypes.bool,
        sso: PropTypes.bool,
        colorScheme: PropTypes.string,
        changeColorScheme: PropTypes.func,
    }

    handleClickOutside(e) {
        return isSettingsIcon(e.target) || isNotificationTarget(e.target) ? false : this.closeSidebar();
    }

    closeSidebar = () => {
        this.props.close();
    }

    onChangeColorScheme = (event) => {
        const value = event.target.value;

        this.props.changeColorScheme(value);

        if (value === 'dark') {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }

    render() {
        const { changeLanguage, pinLeftMenu, leftMenuPinned, withoutPinLeft, colorScheme } = this.props;

        return (
            <div className="right-sidebar-wrap right-sidebar-settings">
                <div className="right-sidebar-header">
                    <Translate content="settings.title" component="span" className="title" />
                    <CustomIcon type="close"
                          className="trigger"
                          onClick={this.closeSidebar}
                    />
                </div>
                <div className="right-sidebar-overflow">
                    <div className="p-0-20">
                        <div className="desc">
                            <Translate content="settings.description" />
                        </div>

                        { !isAncor() && (
                            <div className="setting-item">
                                <div className="title">
                                    <Translate content="settings.language.title" />
                                </div>
                                <div className="body">
                                    <Radio.Group
                                        className="radio-check-group"
                                        defaultValue={counterpart.getLocale()}
                                        onChange={() => changeLanguage()}
                                    >
                                        <Radio.Button className="test" value="ru">
                                            <Translate content="settings.language.russian" />
                                        </Radio.Button>
                                        <Radio.Button value="en">
                                            <Translate content="settings.language.english" />
                                        </Radio.Button>
                                    </Radio.Group>
                                </div>
                            </div>
                        )}
                        { !withoutPinLeft &&
                            <div className="setting-item">
                                <div className="title">
                                    <Translate content="settings.workspace" />
                                </div>
                                <div className="body">
                                    <div className="switch-box">
                                        <label>
                                            <Translate content="settings.fix_panel" />
                                        </label>
                                        <Switch
                                            checked={leftMenuPinned}
                                            onChange={value => pinLeftMenu(value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        { !this.props.sso && isNotificationsEnabled ? (
                            <Fragment>
                                <div className="setting-item">
                                    <div className="title">
                                        <Translate content="settings.color_scheme.title" />
                                    </div>
                                    <div className="body">
                                        <Radio.Group
                                            className="radio-check-group"
                                            value={colorScheme}
                                            onChange={this.onChangeColorScheme}
                                        >
                                            { colorSchemes.map(({ value, translate }) => (
                                                <Radio.Button className={`cs-${value}`} value={value} key={value}>
                                                    <Translate content={`settings.color_scheme.${translate}`} />
                                                </Radio.Button>
                                            ))}
                                        </Radio.Group>
                                    </div>
                                </div>
                                { !withoutPinLeft && (
                                    <Notifications />
                                )}
                            </Fragment>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
